<div class="row p-1">
  <div class="col-12 pageTitle pl-0">
    <h2>
      &nbsp;&nbsp;&nbsp;<i class="pi pi-shield"> &nbsp; </i>Change Password
    </h2>
  </div>
</div>

<div class="grid mt-1 ml-1">
  <div class="card card-w-title col-11 md:col-4">
    <div class="">
      <div class="changePassword">
        <h3 class="p-message">Reset Password</h3>
      </div>

      <div class="grid ml-4">
        <form
          [formGroup]="changePassword"
          (ngSubmit)="resetPassword()"
          class="w-12"
        >
          <div class="col-12">
            <span class="field p-float-label">
              <input
                id="float-input"
                type="password"
                appFormErrorMessages
                pInputText
                formControlName="currentPassword"
                class="text-base text-color p-2 col-11"
                autocomplete="new-password"
              />
              <label for="float-input">
                <span class="required-asteric"> * </span>Current Password</label
              >
            </span>
          </div>
          <div class="col-12">
            <span class="field p-float-label">
              <input
                id="float-input1"
                type="password"
                appFormErrorMessages
                pInputText
                formControlName="newPassword"
                class="text-base text-color p-2 col-11"
              autocomplete="new-password"
              />

              <label for="float-input1">
                <span class="required-asteric"> * </span>New Password</label
              >
            </span>
          </div>
          <div class="col-12">
            <span class="field p-float-label">
              <input
                id="float-input2"
                type="password"
                appFormErrorMessages
                pInputText
                formControlName="confirmPassword"
                class="text-base text-color p-2 col-11"
               autocomplete="new-password"
              />
              <label for="float-input1">
                <span class="required-asteric"> * </span>Confirm Password</label
              >
            </span>
          </div>

          <div class="col-12">
            <button
              pButton
              type="submit"
              label="Save"
              icon="pi pi-save"
              class="p-button-plain buttonWidth-8 fl"
            ></button>
          </div>
        </form>

        <p>&nbsp;</p>

        <div
          class="col-12 p-messagesp-messages-summary border-radius-5"
          *ngIf="ShowErrorSummary"
          style="font-size: 1.2rem; color: #ff6a00"
        >
          <i class="pi pi-times"> &nbsp; </i>
          <span [innerHTML]="errorValidationSummary"></span>
        </div>
      </div>
    </div>
  </div>
</div>
